import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loader-spinner" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LNavbarHome = _resolveComponent("LNavbarHome")!
  const _component_LNavbar = _resolveComponent("LNavbar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LFooter = _resolveComponent("LFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.isHome)
      ? (_openBlock(), _createBlock(_component_LNavbarHome, { key: 0 }))
      : (_openBlock(), _createBlock(_component_LNavbar, { key: 1 })),
    _createVNode(_component_router_view),
    _createVNode(_component_LFooter, { "list-data": _ctx.listSocialMedia }, null, 8, ["list-data"])
  ], 64))
}